import React from 'react';
import styled from 'styled-components';
import { Modal } from '@/features/modals/components';
import { SaveQueryAsNew } from './SaveQueryAsNew';
import { ReplaceExistingQuery } from './ReplaceExistingQuery';

const RadioGroup = styled.div`
  display: flex;
  gap: var(--spacing-s);
  padding: var(--spacing-l);

  label,
  input {
    margin: 0;
  }

  label {
    font-size: 13px;
    cursor: pointer;
  }

  label:first-of-type {
    margin-right: var(--spacing-s);
  }
`;

const SAVE_TYPE = {
  asNew: 'asNew',
  replaceExisting: 'replaceExisting',
} as const;

const SAVE_TYPE_TO_CONTENT_COMPONENT = {
  [SAVE_TYPE.asNew]: SaveQueryAsNew,
  [SAVE_TYPE.replaceExisting]: ReplaceExistingQuery,
} as const;

export const SaveQueryModal = () => {
  const [saveType, setSaveType] = React.useState<keyof typeof SAVE_TYPE>(
    SAVE_TYPE.asNew,
  );

  const ContentComponent = SAVE_TYPE_TO_CONTENT_COMPONENT[saveType];

  return (
    <Modal title="Save query as" noDefaultFooter>
      <RadioGroup>
        <input
          type="radio"
          id={SAVE_TYPE.asNew}
          checked={saveType === SAVE_TYPE.asNew}
          onChange={() => setSaveType(SAVE_TYPE.asNew)}
        />
        <label htmlFor={SAVE_TYPE.asNew}>Save new</label>

        <input
          type="radio"
          id={SAVE_TYPE.replaceExisting}
          checked={saveType === SAVE_TYPE.replaceExisting}
          onChange={() => setSaveType(SAVE_TYPE.replaceExisting)}
        />
        <label htmlFor={SAVE_TYPE.replaceExisting}>
          Replace existing query
        </label>
      </RadioGroup>
      <ContentComponent />
    </Modal>
  );
};
